export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "fa7a3252-812e-4c65-b9ec-c9399d8a9720";
export const MODAL_CLOSE_SEC = 2.5;
